<template>
  <div class="d-flex min-vh-100">
    <CContainer fluid>
      <CCard  
        accentColor="#122efe"
        align="center"
      >
        <CCardHeader class="d-flex justify-content-between">
          <div class="d-flex align-items-baseline">
            <CIcon name="cil-people" size="xl" class="mr-2"/> 
            <h3 class="m-0 font-weight-bold">Usuarios</h3>
          </div>
          <CButton
            shape="square"   
            color="info"
            @click="$router.push('usuarios/crear')"
          >
          Crear usuario &nbsp;<CIcon name='cil-plus' size='md' style="fill: white; stroke: 2px;"/> 
          </CButton>
        </CCardHeader>
        <CCardBody>
          <CRow class="justify-content-center">
            <div class="responsive-datatables">
              <datatable 
                class='table datatable' 
                :columns='tableFields' 
                :data='usersData'
                :per-page='10'
              >
                    <template slot-scope="{ row }">
                        <tr>
                            <td>{{ row.username }}</td>
                            <td>{{ row.department }}</td>
                            <td>{{ row.first_name }}</td>
                            <td>{{ row.last_name }}</td>
                            <td>{{ row.role.name }}</td>
                            <td>{{ row.email }}</td>
                            <td>{{ row.phone }}</td>
                            <td>
                              <div class="d-flex justify-content-center align-items-center">
                                <CButton
                                  class="mr-1"
                                  v-c-tooltip='"Modificar Usuario"'
                                  color="warning"
                                  size="sm"
                                  @click="updateUser(row.id)"
                                >
                                <CIcon name='cil-pencil' size='sm'  />
                                </CButton>
                                
                                <CButton
                                  v-if="row.deleted_at != null"
                                  class="icon-center"
                                  v-c-tooltip='"Activar Usuario"'
                                  color="dark"
                                  size='sm'
                                  @click="userActivation(row.id, true)"
                                >
                                  <CIcon name="cil-chevron-top" size="sm" />
                                </CButton>

                                <CButton
                                  v-else
                                  class="icon-center"
                                  v-c-tooltip='"Desactivar Usuario"'
                                  color="danger"
                                  size="sm"
                                  @click="userActivation(row.id, false)"                                  
                                >
                                  <CIcon name="cil-x" size="sm" />
                                </CButton>
                                
                              </div>
                            </td>
                        </tr>
                    </template>
              </datatable>
              <datatable-pager v-model='page' class='paginator' type='short'></datatable-pager>
            </div>
          </CRow>
        </CCardBody>
      </CCard>
    </CContainer>
  </div>
</template>

  <script>
    import axios from 'axios'    
import usersData from '../users/UsersData';
    export default {
      data() {
        return {
            loading: true,
            page: 1,
            row: 10,
            tableFields: [
                {label: 'Usuario', field: 'username'},
                {label: 'Sector', field: 'department'},
                {label: 'Nombre', field: 'first_name'},
                {label: 'Apellido', field: 'last_name'},
                {label: 'Perfil del Usuario', field: 'role'},
                {label: 'Email', field: 'email'},
                {label: 'Teléfono', field: 'phone'},
                {label: 'Acciones', field: 'actions'}
                ],
          usersData: []
        }
      },    
      methods: {
          getUsersData(){
            let me = this;
            return this.$api.users.index().then(resp => me.usersData = resp.data.data);
          },
          
          updateUser(user_id){
            this.$router.push({ path: `usuarios/modificar/${user_id}`});               
          },

          userActivation(user_id, activate){
            let me = this;
            this.$swal.fire({
              title: activate ? '¿Activar usuario?' : '¿Desactivar usuario?',
              text: activate ? "El usuario podrá volver a utilizar el sistema" : "El usuario no podrá utilizar el sistema",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: activate ? 'Activar' : 'Desactivar',
              cancelButtonText: 'Cancelar'
            }).then((result) => {
              if (result.isConfirmed) {
                let request = activate ?
                  this.$api.users.activate(user_id) : 
                  this.$api.users.deactivate(user_id);

                request
                .then(response => {
                  let text = activate ? 'Activado' : 'Desactivado';
                  this.$swal.fire(text, '', 'success');
                  this.getUsersData();
                })
                .catch(error => {
                  let text = activate ? 'Activar' : 'Desactivar';
                  this.$swal.fire({
                    title: `Error al ${text}`,
                    text: `No se pudo ${text}`,
                    icon: 'error'
                  });
                });
              }
            })
          }
          
      },
      computed: {
        
      },
      mounted(){
        this.getUsersData();
      }

    }
  
  </script>

  <style scoped>
    .responsive-datatables{
      padding: 2rem;
      width: 100%;
      height: 100%;

    }
    .btn-circle {
      width: 30px;
      height: 30px;
      padding: 6px 0px;
      border-radius: 15px;
      text-align: center;
      font-size: 12px;
      line-height: 1.42857;
    }
    .icon-center{
      display: flex;
      align-items: inherit;
      justify-content: center;
    }
  </style>
